import { Group, Paper, Stack, Text, Timeline } from '@mantine/core'
import { IconCheck } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { ReactNode } from 'react'

export interface HandoverStep {
  key: string
  label: string
  date?: string | null
  actorName?: string | null
  done: boolean
  action?: ReactNode
}

const stepDetail = (step: HandoverStep) => {
  if (!step.done) return 'En attente'
  const parts = []
  if (step.date) parts.push(dayjs(step.date).format('DD/MM/YYYY HH:mm'))
  if (step.actorName) parts.push(step.actorName)
  return parts.length ? parts.join(' — ') : 'Fait'
}

export function HandoverTimeline({ title, steps }: { title: string; steps: HandoverStep[] }) {
  const activeIndex = steps.filter((step) => step.done).length

  return (
    <Paper withBorder p="md" radius="md">
      <Stack gap="md">
        <Text fw={700}>{title}</Text>
        <Timeline active={activeIndex} color="green" bulletSize={24} lineWidth={2}>
          {steps.map((step) => (
            <Timeline.Item
              key={step.key}
              bullet={step.done ? <IconCheck size={14} /> : undefined}
              title={
                <Group justify="space-between" align="center" gap="xs">
                  <Text fw={600}>{step.label}</Text>
                  {!step.done && step.action}
                </Group>
              }
            >
              <Text size="sm" c="dimmed">
                {stepDetail(step)}
              </Text>
            </Timeline.Item>
          ))}
        </Timeline>
      </Stack>
    </Paper>
  )
}
